import { useEffect, useState } from 'react';

/**
 * Matches CSS `(max-width: maxPx px)`. Used to align with the document editor
 * mobile layout (see `editor.scss`, Editor.js toolbar at 650px).
 */
export function useMediaMaxWidth(maxPx: number): boolean {
  const query = `(max-width: ${maxPx}px)`;
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
